import React from 'react';
import { Link, useParams } from 'react-router-dom';
import UserAdd from './UsersAdd';
// import Swal from 'sweetalert2';
// import Constant from '../../../Constant.js';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetail } from '../../../actions';
import { useEffect } from 'react';

// class UserAddTab extends React.Component {

const UsersAddTab = () => {
  const { user_id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserDetail(user_id));
  }, []);

  const dataResponse = useSelector((state) => state.home.userDetail);

  console.log('dataResponse', dataResponse);

  const data = dataResponse?.response?.[0];

  return (
    <div className="main-body">
      <div className="page-wrapper">
        <div className="page-header">
          <div className="row align-items-end">
            <div className="col-lg-8">
              <div className="page-header-title">
                <div className="d-inline">
                  <h4>
                    Edit : {data?.firstName} {data?.lastName}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="page-header-breadcrumb">
                <ul className="breadcrumb-title">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="feather icon-home"></i>{' '}
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/user">User</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit User</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-border-default">
                <div className="card-block">
                  {/* <ul className='nav nav-tabs  tabs' role='tablist'>
											{this.state.language_data !== undefined &&
											this.state.language_data !== []
												? this.state.language_data.map(language => (
														<li
															className='nav-item'
															key={language.id}
															onClick={this.handleLanguage.bind(
																this,
																language.id
															)}>
															<a
																className={
																	this.state.language_id === language.id
																		? 'nav-link active'
																		: 'nav-link'
																}
																id={'language_' + language.id}
																data-toggle='tab'
																href={'#car_user_' + language.id}
																role='tab'
																aria-controls={'car_user_' + language.id}
																aria-selected='true'>
																{language.name}
															</a>
														</li>
												  ))
												: ''}
										</ul> */}
                  <div className="tab-content tabs">
                    <div
                      className="tab-pane  active"
                      id={'car_user_'}
                      role="tabpanel"
                      aria-labelledby=""
                    >
                      <UserAdd
                        // language_id={language_id}
                        // goBack={history.goBack}
                        data={data}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersAddTab;
// export default withRouter(UserAddTab);
